import { useLocation, useNavigate, useParams } from 'react-router-dom';
import './index.less';
import { IconButton, Input, MenuItem, MenuList, ModelListItem, SideHeader, TnModal, ContextMenu, LeftSideList, ContextMenuModal } from 'bimui';
import { ReactComponent as AddSvg } from 'bimui/dist/c1/icons/add.svg';
import { ReactComponent as BlackAddSvg } from "bimui/dist/c1/icons/add-black.svg"
import { ReactComponent as Add32Svg } from 'bimui/dist/c1/icons/new-default_32.svg';
import { ReactComponent as Add32WhiteSvg } from 'bimui/dist/c1/icons/new-default_32_white.svg';
import { ReactComponent as Add16GreySvg } from 'bimui/dist/c1/icons/new-default_grey.svg';
import { ReactComponent as CircleConfirmSvg } from 'bimui/dist/c1/icons/circle-confirm.svg';
import { ReactComponent as CircleCancelSvg } from 'bimui/dist/c1/icons/circle-cancel.svg';
import { ReactComponent as GridSvg } from 'bimui/dist/c1/icons/grid.svg';
import { ReactComponent as GridWhiteSvg } from 'bimui/dist/c1/icons/grid-white.svg';
import { ReactComponent as FastGenSvg } from 'bimui/dist/c1/icons/fast-generation.svg';
import { ReactComponent as FastGenWhiteSvg } from 'bimui/dist/c1/icons/fast-generation-white.svg';
import { ReactComponent as FastGenGreenSvg } from 'bimui/dist/c1/icons/fast-generation-green.svg';
import { useContext, useEffect, useRef, useState } from 'react';
import { createRegion, deleteRegion, findRegions, updateRegion } from '@/declare/api/project/region';
import { Region } from '@/declare/interface/project/region';
import { message } from 'antd/lib';
import { Modal, Table } from 'antd';
import { Storey } from '@/declare/interface/project/storey';
import { createStorey, deleteStorey, getStorey, updateStorey } from '@/declare/api/project/storey';
import { EngineContext, NavigationContext, PositionContext } from '@/App';
import { Primitive, PythaEventDataChange, PythaEventObject, PythaEventSetting, SETTING_KEY } from 'pytha2';
import { Matrix4, Vector3 } from 'three';
import { EventGraphUpdateAxisNetElevation } from '@/plugin/event-graph/EGUpdateAxisNetElevation';
import { findPrimitivesByUuids } from '@/declare/api/geometry/primitive';
import { EventGraphRedrawAxisNet } from '@/plugin/event-graph/EGRedrawAxisNet';
import { EventGraphDeleteAxisNet } from '@/plugin/event-graph/EGDeleteAxisNet';
import { EventGraphDeleteVeritcalAxisLine } from '@/plugin/event-graph/EGDeleteVeritcalAxisLine';
import { EventGraphGenVerticalAxisLine } from '@/plugin/event-graph/EGGenVerticalAxisLine';
import { BaseUtils } from "tnbase";
import classNames from 'classnames';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import { generateUUID } from 'three/src/math/MathUtils';
import { AxisNetPrimitive } from '@/plugin/primitive/AxisNetPrimitive';
import { FileType } from '@/declare/enums/file-type';
import { addFile, findFileByProjectUuid } from '@/declare/api/project/file';
import { File } from "@/declare/interface/project/file"
import localStore from '@/store/local-store';

interface IRegionProps {
    region: Region;
    renameUuid: string;
}

enum EditColType {
    name,
    elevation,  // 标高
    height,     // 层高
    ALL,       // 编辑所有
}

const DefaultHeight = 3000.0;

export default function PositionPanel() {
    const { projectUuid } = useParams();

    const [regions, setRegions] = useState<Region[]>([]);   // 区域
    const [storeys, setStoreys] = useState<Storey[]>([]);   // 楼层
    const [activeStoreyUuids, setActiveStoreyUuids] = useState<string[]>([]); // 当前选中的楼层
    const activeStoreyUuidsRef = useRef([]);

    const [loading, setLoading] = useState(false);
    const [activeStoreyUuid, setActiveStoreyUuid] = useState<string>(null); // 当前选中的楼层
    // const [activeRegionUuid, setActiveRegionUuid] = useState<string>(null); // 当前选中的区域
    const [activeRegion, setActiveRegion] = useState<Region>(null); // 当前选中的区域
    const activeRegionUuidRef = useRef(null);

    const activeRegionRef = useRef(null);
    const activeStoreyUuidRef = useRef(null);
    const [editStoreyUuid, setEditStoreyUuid] = useState<string>(null); // 当前在编辑的楼层
    const [editCol, setEditCol] = useState<number>(null); // 当前在编辑的列
    const [inputValue, setInputValue] = useState<string>(null); // 当前输入的值
    const [inputValueName, setInputValueName] = useState<string>(null); // 名称输入框值
    const [inputValueElevation, setInputValueElevation] = useState<string>(null); // 标高输入框值

    // 右键菜单相关
    const [rtxVisible, setRtxVisible] = useState(false);
    const [rtxLeft, setRtxLeft] = useState(0);
    const [rtxTop, setRtxTop] = useState(0);
    const [rtxRegionUuid, setRtxRegionUuid] = useState<string>(null);
    const [rtxStoreyUuid, setRtxStoreyUuid] = useState<string>(null);
    const [renameRegionUuid, setRenameRegionUuid] = useState<string>(null); // 重命名区域
    const navigate = useNavigate(); // 路由导航
    // 导航存储
    const navigateContext = useContext(NavigationContext);
    // 引擎存储
    const engineContext = useContext(EngineContext);
    // 空间定位存储
    const positionContext = useContext(PositionContext);
    const [hoverStoreyUuid, setHoverStoreyUuid] = useState<string>(null); // 悬浮的楼层
    const location = useLocation(); // 路由地址
    const dbClickRef = useRef(false); // 双击判断
    const [contextMenuLeft, setContextMenuLeft] = useState<number>(0) // 添加选项弹窗的左方位置
    const [contextMenuTop, setContextMenuTop] = useState<number>(0) // 添加选项弹窗的上方位置
    const [contextMenuVisible, setContextMenuVisible] = useState<boolean>(false) // 添加选项弹窗是否可见

    useEffect(() => {
        if (!projectUuid || projectUuid == "undefined") return;
        generateData();
    }, [projectUuid])

    useEffect(() => {
        activeStoreyUuidsRef.current = activeStoreyUuids;
    }, [activeStoreyUuids])

    useEffect(() => {
        activeStoreyUuidRef.current = activeStoreyUuid;
    }, [activeStoreyUuid])

    useEffect(() => {
        activeRegionRef.current = activeRegion;
        setRenameRegionUuid(null);
        setActiveStoreyUuids([]);
        let axisNetUuids = activeRegion?.storeys?.map(item => item?.axisNetUuid)?.filter(item => !!item) || [];
        positionContext.updateAxisNetUuids(axisNetUuids);
        // 切换了区域，设置激活的楼层为空
        setActiveStoreyUuid(null);
        const region = regions.find(r => r.uuid === activeRegion?.uuid);
        if (!region) {
            setStoreys([]);
            return;
        }
        setStoreys(region?.storeys || []);
    }, [activeRegion])


    /**
    * 注册事件到引擎、加载图形
    */
    useEffect(() => {
        if (!engineContext?.engine) return;
        if (!engineContext?.engine?.storage) return;
        // 注册轴网相关的事件图
        engineContext?.engine?.storage.registerStore.registEventGraph(EventGraphUpdateAxisNetElevation.cmd, EventGraphUpdateAxisNetElevation);
    }, [engineContext?.engine]);

    const generateData = () => {
        findRegions(projectUuid).then(res => {
            setRegions(res.data || []);
            if (res.data?.length > 0 && !activeRegion) {
                setActiveRegion(res.data[0]);
            }
        }).catch(err => {
            setRegions([]);
            message.error("获取区域失败");
        })
    }

    // 添加区域
    const handleClickAddRegion = () => {
        const newRegion: Region = {
            uuid: BaseUtils.genUUID(),
            name: "新区域",
            projectUuid: projectUuid
        }
        createRegion(projectUuid, newRegion).then(res => {
            newRegion.id = res.data;
            setRegions([...regions, newRegion]);
            // message.success("添加成功");
        }).catch(err => {
            message.error("添加失败");
        })
    }

    const handleClickAddStorey = (region) => {
        if (!region) return;
        if (!!loading) return;
        // const region = regions[index];
        const storeys = region.storeys || [];
        let elevation = 0.0;
        if (storeys.length > 0) {
            elevation = (storeys[storeys.length - 1].height / 1000) + storeys[storeys.length - 1].elevation;
        }

        const newStorey: Storey = {
            uuid: BaseUtils.genUUID(),
            name: `${storeys.length + 1}F`,
            projectUuid: projectUuid,
            regionUuid: region?.uuid,
            height: DefaultHeight,
            elevation: elevation
        }
        setLoading(true);
        createStorey(projectUuid, newStorey).then(res => {
            newStorey.id = res.data.id;
            newStorey.axisNetUuid = res.data.axisNetUuid;
            storeys.push(newStorey);
            region.storeys = storeys;
            setRegions([...regions]);
            // message.success("添加成功");
        }).catch(err => {
            message.error("添加失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleDbClickInput = (e, storey: Storey, col: EditColType) => {
        dbClickRef.current = true;
        e.stopPropagation();
        e.preventDefault();
        if (!storey) {
            message.warning("楼层信息有误");
            return;
        }
        // 双击某一层，设置激活的层为这一层
        setActiveStoreyUuid(storey.uuid);
        setEditCol(col);
        setInputValue(storey.height.toFixed(0));
        setInputValueName(storey.name);
        setInputValueElevation(storey.elevation.toFixed(3));
        setEditStoreyUuid(storey.uuid);
    }

    /**
     * 修改楼层
     * @param index 区域的下标 
     * @returns 
     */
    const handleUpdateStorey = (storey: Storey, isAll?: boolean) => {
        if (loading) {
            setEditStoreyUuid(null);
            return;
        }
        if (editCol === EditColType.ALL && isAll == null) return;
        if (!storey) {
            message.warning("楼层信息有误");
            setEditStoreyUuid(null);
            return;
        }
        if (editCol === EditColType.name || editCol === EditColType.ALL) {
            if (inputValue == null || inputValue == '') {
                message.warning("名称不能为空");
                setEditStoreyUuid(null);
                return;
            }
            if (editCol !== EditColType.ALL && inputValueName === storey.name) {
                setEditStoreyUuid(null);
                return;
            }
        } else if (editCol === EditColType.elevation || editCol === EditColType.ALL) {
            if (inputValueElevation == null || inputValueElevation == '' || isNaN(parseFloat(inputValueElevation))) {
                message.warning("标高只能输入数字");
                setEditStoreyUuid(null);
                return;
            }
            if (editCol !== EditColType.ALL && parseFloat(inputValueElevation) === storey.elevation) {
                setEditStoreyUuid(null);
                return;
            }
        } else if (editCol === EditColType.height || editCol === EditColType.ALL) {
            if (inputValue == null || inputValue == '' || isNaN(parseFloat(inputValue))) {
                message.warning("高度只能输入数字");
                setEditStoreyUuid(null);
                return;
            }
            if (editCol !== EditColType.ALL && parseFloat(inputValue) === storey.height) {
                setEditStoreyUuid(null);
                return;
            }
        }

        // 标高
        const elevationValue = parseFloat(inputValueElevation);
        storey.elevation = elevationValue;
        // 高度
        const value = parseFloat(inputValue);
        storey.height = value;
        // 名称
        storey.name = inputValueName;

        // 准备一个
        let redrawAxisNets = [];
        // 修改竖向轴线
        let parStoreys = [];
        if (storey?.axisNetUuid) {
            let par = {
                uuid: storey?.axisNetUuid,
                // elevation: elevationValue * 1000,
                elevation: elevationValue,
            }
            redrawAxisNets.push(par);
            parStoreys.push(storey);
        }
        // 更新楼层标高
        const idx = storeys.findIndex(s => s.uuid === editStoreyUuid);
        if (idx !== 0) {
            parStoreys.push(storeys[idx - 1]);
        }
        for (let i = idx + 1; i < storeys.length; i++) {
            const newElevation = (storeys[i - 1].height / 1000) + storeys[i - 1].elevation
            storeys[i].elevation = newElevation;

            if (storeys[i]?.axisNetUuid) {
                let par = {
                    uuid: storeys[i]?.axisNetUuid,
                    // elevation: newElevation * 1000,
                    elevation: newElevation,
                }
                redrawAxisNets.push(par);
                parStoreys.push(storeys[i]);
            }
        }
        setLoading(true);
        updateStorey(storey.uuid, storey).then(res => {
            let uuids = redrawAxisNets?.map(item => item.uuid) || [];
            if (engineContext?.engine && !location.pathname.includes("axis-net")) {
                findPrimitivesByUuids(uuids).then(res => {
                    // 激活修改轴网标高
                    engineContext.emitCommand(EventGraphUpdateAxisNetElevation.cmd);
                    let pythaEvent = new PythaEventObject();
                    pythaEvent.data = redrawAxisNets;
                    engineContext.engine.eventMediator?.emitEvent(pythaEvent);

                    let primitives = [];
                    let jsonList = res.data || [];
                    jsonList?.forEach(item => {
                        let json = item.properties;
                        let primitive: Primitive = new Primitive();
                        primitive.fromJson(json);
                        // 处理子图元
                        let childJson = json['children'] || [];
                        for (let child of childJson) {
                            let childPrimitive = new Primitive();
                            childPrimitive.fromJson(child);
                            primitive.addChildPrimitive(childPrimitive);
                        }
                        primitive.updateWorldModelMatrix(false, true);
                        primitives.push(primitive);
                    })
                    // 重新打断轴网
                    reBreakAxisNet(primitives);
                    // 重新生成竖向轴线
                    reGenVLine([], parStoreys);
                }).catch(err => {
                    console.log('err', err)
                    message.error("服务器异常，重新打散轴网失败");
                })
            } else if (engineContext?.engine && location.pathname.includes("axis-net")) {
                // // 触发重新渲染
                positionContext.render();
            }

            activeRegion.storeys = storeys;
            let regionIdx = regions?.findIndex(r => r.uuid === activeRegion?.uuid);
            regions[regionIdx].storeys = storeys;
            setRegions([...regions]);
            // message.success("修改成功");
        }).catch(err => {
            console.log('err', err)
            if (err.data.message) {
                message.error(err.data.message);
            } else {
                message.error("修改失败");
            }
        }).finally(() => {
            setEditStoreyUuid(null);
            setLoading(false);
        })
    }

    // 激活右键菜单
    const handleRtx = (e, regionUuid: string, storeyUuid?: string) => {
        setRtxLeft(e.clientX);
        setRtxTop(e.clientY);
        e.preventDefault();
        e.stopPropagation();
        if (regionUuid != null) {
            setRtxRegionUuid(regionUuid);
            setRtxVisible(true);
        }
        if (storeyUuid != null) {
            setRtxStoreyUuid(storeyUuid);
            setRtxVisible(true);
            // 右键，设置激活的层为右键的层
            setActiveStoreyUuid(storeyUuid);
        }
    }

    /**
     * 激活区域重命名
     */
    const activeRenameRegion = (regionUuid: string) => {
        if (regionUuid == null) {
            regionUuid = rtxRegionUuid;
            setRtxRegionUuid(null);
            setRtxVisible(false);
        }
        const region = regions.find(r => r.uuid == regionUuid);
        if (!region) {
            setRtxRegionUuid(null);
            setRtxVisible(false);
            return;
        }
        setRenameRegionUuid(regionUuid);
        setInputValue(region.name);
        setRtxVisible(false);
    }

    // 激活删除区域
    const activeDeleteRegion = () => {
        setRtxVisible(false);
        const idx = regions.findIndex(r => r.uuid == rtxRegionUuid);
        if (idx === -1) {
            message.warning("区域信息有误");
            return;
        }
        if (loading) return;
        TnModal().deleteModal({
            closable: false,
            onOk() {
                setLoading(true);
                deleteRegion(rtxRegionUuid).then(res => {
                    regions.splice(idx, 1);
                    setRegions([...regions]);
                    setActiveRegion(null);
                    if (regions?.length > 0) {
                        setActiveRegion(regions[0]);
                    } else {
                        setActiveRegion(null);
                    }
                    // message.success("删除成功");
                }).catch(err => {
                    message.error("删除失败");
                }).finally(() => {
                    setRtxRegionUuid(null);
                    setLoading(false);
                    Modal.destroyAll();
                })
            },
        })
    }

    // 激活删除楼层
    const activeDeleteStorey = (regionUuid?: string, storeyUuid?: string) => {
        if (regionUuid == null) {
            regionUuid = rtxRegionUuid;
        }
        if (storeyUuid == null) {
            storeyUuid = rtxStoreyUuid;
        }
        setRtxVisible(false);
        const idx = regions.findIndex(r => r.uuid == regionUuid);
        if (idx === -1) {
            message.warning("区域信息有误");
            return;
        }
        const storeys = regions[idx].storeys || [];
        const storeyIdx = storeys.findIndex(s => s.uuid == storeyUuid);
        if (storeyIdx === -1) {
            message.warning("楼层信息有误");
            return;
        }
        let text = null;
        let okText = null;
        let cancelText = null;
        if (storeyIdx !== storeys.length - 1) {
            const firstStorey = storeys[storeyIdx + 1];
            text = `是否将${firstStorey.name}`;
            if (storeyIdx < storeys.length - 2) {
                const endStorey = storeys[storeys.length - 1];
                text += `~${endStorey.name}`;
            }
            text += `下移`;
            okText = "是";
            cancelText = "否";
        }
        if (loading) return;
        TnModal().specialDeleteModal({
            closable: true,
            content: text,
            okText: okText,
            cancelText: cancelText,
            onOk() {
                setLoading(true);
                deleteStorey(storeyUuid).then(res => {
                    const storey = { ...storeys[storeyIdx] };
                    let redrawAxisNets = [];
                    let okParStoreys = [];
                    storeys.splice(storeyIdx, 1);
                    storeys.forEach((storey, index) => {
                        if (index !== 0) {
                            storey.elevation = storeys[index - 1].elevation + (storeys[index - 1].height / 1000);
                            if (storey?.axisNetUuid) {
                                let par = {
                                    uuid: storey?.axisNetUuid,
                                    // elevation: storey.elevation * 1000,
                                    elevation: storey.elevation,
                                }
                                redrawAxisNets.push(par);
                            }
                            okParStoreys.push(storey);
                        }
                    })

                    if (!!storey?.axisNetUuid && engineContext?.engine && !location.pathname.includes("axis-net")) {
                        let pri: Primitive = engineContext?.engine?.storage?.primitiveStore.primitiveDict[storey?.axisNetUuid];
                        if (pri) {
                            let uuids = redrawAxisNets?.map(item => item.uuid) || [];
                            findPrimitivesByUuids(uuids).then(res => {
                                // 删除轴网图
                                engineContext.emitCommand(EventGraphDeleteAxisNet.cmd);
                                let deleteAxisNetEvent = new PythaEventObject();
                                deleteAxisNetEvent.data = { axisNetPrimitives: [pri] };
                                engineContext.engine.eventMediator?.emitEvent(deleteAxisNetEvent);

                                // 激活修改轴网标高
                                engineContext.emitCommand(EventGraphUpdateAxisNetElevation.cmd);
                                let pythaEvent = new PythaEventObject();
                                pythaEvent.data = redrawAxisNets;
                                engineContext.engine.eventMediator?.emitEvent(pythaEvent);

                                let primitives = [];
                                let jsonList = res.data || [];
                                jsonList?.forEach(item => {
                                    let json = item.properties;
                                    let primitive: Primitive = new Primitive();
                                    primitive.fromJson(json);
                                    // 处理子图元
                                    let childJson = json['children'] || [];
                                    for (let child of childJson) {
                                        let childPrimitive = new Primitive();
                                        childPrimitive.fromJson(child);
                                        primitive.addChildPrimitive(childPrimitive);
                                    }
                                    primitive.updateWorldModelMatrix(false, true);
                                    primitives.push(primitive);
                                })
                                // 重新打断轴网
                                reBreakAxisNet(primitives);
                                // 重新生成竖向轴线
                                reGenVLine([storey], okParStoreys);
                            }).catch(err => {
                                console.log('err', err)
                                message.error("服务器异常，重新打散轴网失败");
                            })
                        }
                    } else if (!!storey?.axisNetUuid && engineContext?.engine && location.pathname.includes("axis-net")) {
                        positionContext.render();
                    }

                    // 删除，设置激活的层其它层或空
                    if (storeyUuid === activeStoreyUuidRef.current) {
                        if (storeys.length > 0) {
                            setActiveStoreyUuid(storeys[Math.min(storeyIdx, storeys.length - 1)].uuid);
                        } else {
                            setActiveStoreyUuid(null);
                        }
                    }
                    setRegions([...regions]);
                    if (activeRegion) {
                        const idx2 = activeRegion?.storeys?.findIndex(s => s.uuid == storeyUuid);
                        if (idx2 !== -1) {
                            activeRegion.storeys.splice(idx2, 1);
                            setActiveRegion({ ...activeRegion });
                        }
                    }
                    // message.success("删除成功");
                }).catch(err => {
                    console.log('err', err)
                    message.error("删除失败");
                }).finally(() => {
                    setRtxRegionUuid(null);
                    setRtxStoreyUuid(null);
                    setLoading(false);
                    Modal.destroyAll();
                })
            },
            onCancel: () => {
                setLoading(true);
                deleteStorey(storeyUuid, { adjust: false }).then(res => {
                    const storey = { ...storeys[storeyIdx] };
                    if (!!storey?.axisNetUuid && engineContext?.engine && !location.pathname.includes("axis-net")) {
                        let pri: Primitive = engineContext?.engine?.storage?.primitiveStore.primitiveDict[storey?.axisNetUuid];
                        if (pri) {
                            // 删除轴网图
                            engineContext.emitCommand(EventGraphDeleteAxisNet.cmd);
                            let deleteAxisNetEvent = new PythaEventObject();
                            deleteAxisNetEvent.data = { axisNetPrimitives: [pri] };
                            engineContext.engine.eventMediator?.emitEvent(deleteAxisNetEvent);
                            let parStoreys = [];
                            if ((storeyIdx + 1) <= storeys?.length) {
                                parStoreys.push({ ...storeys[storeyIdx + 1] })
                            }
                            if ((storeyIdx - 1) >= 0) {
                                parStoreys.push({ ...storeys[storeyIdx - 1] })
                            }
                            reGenVLine([storey], parStoreys);
                        }
                    } else if (!!storey?.axisNetUuid && engineContext?.engine && location.pathname.includes("axis-net")) {
                        positionContext.render();
                    }
                    storeys.splice(storeyIdx, 1);
                    // 删除，设置激活的层其它层或空
                    if (storeyUuid === activeStoreyUuidRef.current) {
                        if (storeys.length > 0) {
                            setActiveStoreyUuid(storeys[Math.min(storeyIdx, storeys.length - 1)].uuid);
                        } else {
                            setActiveStoreyUuid(null);
                        }
                    }
                    setRegions([...regions]);
                    if (activeRegion) {
                        const idx2 = activeRegion?.storeys?.findIndex(s => s.uuid == storeyUuid);
                        if (idx2 !== -1) {
                            activeRegion.storeys.splice(idx2, 1);
                            setActiveRegion({ ...activeRegion });
                        }
                    }
                    // message.success("删除成功");
                }).catch(err => {
                    console.log('err', err)
                    message.error("删除失败");
                }).finally(() => {
                    setRtxRegionUuid(null);
                    setRtxStoreyUuid(null);
                    setLoading(false);
                    Modal.destroyAll();
                })
            }
        })
    }

    // 激活复制楼层
    const activeCopyStorey = async (regionUuid?: string, storeyUuid?: string) => {
        if (regionUuid == null) {
            regionUuid = rtxRegionUuid;
            setRtxVisible(false);
            setRtxRegionUuid(null);
        }
        if (storeyUuid == null) {
            storeyUuid = rtxStoreyUuid;
            setRtxStoreyUuid(null);
        }
        const region = regions.find(r => r.uuid === regionUuid);
        if (!region) {
            message.warning("区域信息有误");
            return;
        }
        const storeys = region.storeys || [];
        const storey = storeys.find(s => s.uuid === storeyUuid);
        if (!storey) {
            message.warning("楼层信息有误");
            return;
        }
        let elevation = 0;
        if (storeys.length > 0) {
            elevation = (storeys[storeys.length - 1].height / 1000) + storeys[storeys.length - 1].elevation;
        }
        const newStorey: Storey = {
            uuid: BaseUtils.genUUID(),
            name: `${storeys.length + 1}F`,
            projectUuid: projectUuid,
            regionUuid: regionUuid,
            height: storey.height,
            elevation: elevation,
        }

        let needRenderAxisNet = null;
        const storeyRes = await getStorey(storey.uuid);
        const oldStorey = storeyRes.data;
        if (oldStorey?.axisNetPrimitive) {
            const priObj = oldStorey?.axisNetPrimitive;
            const priJson = priObj.properties;
            const pri = new Primitive();
            pri.fromJson(priJson);
            // 处理子图元
            let childJson = priJson['children'] || [];
            for (let child of childJson) {
                let childPrimitive = new Primitive();
                childPrimitive.fromJson(child);
                pri.addChildPrimitive(childPrimitive);
            }
            pri.updateWorldModelMatrix(false, true);
            pri.group = [];
            const priClone = pri.clone();
            if (!priClone.localModelMatrix) {
                priClone.localModelMatrix = new Matrix4();
            }
            // priClone.localModelMatrix.elements[14] = elevation * 1000;
            priClone.localModelMatrix.elements[14] = elevation;

            let newAxisNetPrimitive = { ...oldStorey?.axisNetPrimitive };
            newAxisNetPrimitive.properties = priClone.toJson();

            newStorey['axisNetPrimitive'] = newAxisNetPrimitive;
            newStorey['axisNetProperties'] = priClone.toJson();
            newStorey['axisNetUuid'] = priClone.uuid;
            needRenderAxisNet = priClone;
            needRenderAxisNet.needRedraw = true;
            needRenderAxisNet.updateWorldModelMatrix(false, true);
        }
        setLoading(true);
        createStorey(projectUuid, newStorey).then(res => {
            newStorey.id = res.data.id;
            newStorey.axisNetUuid = res.data.axisNetUuid;
            storeys.push(newStorey);
            region.storeys = storeys;
            setRegions([...regions]);
            // activeRegion.storeys.push(newStorey);
            setActiveRegion({ ...activeRegion });
            // 渲染一个轴网
            if (!!needRenderAxisNet && engineContext?.engine && !location.pathname.includes("axis-net")) {
                let dataChange = new PythaEventDataChange({ add_primitives: [needRenderAxisNet] });
                engineContext.engine.eventMediator.emitEvent(dataChange);
                // 打断
                reBreakAxisNet([needRenderAxisNet]);
                // 竖向轴线
                reGenVLine([], [storeys[storeys.length - 2], newStorey]);
            } else if (!!needRenderAxisNet && engineContext?.engine && location.pathname.includes("axis-net")) {
                positionContext.render();
            }
            // message.success("复制成功");
        }).catch(err => {
            message.error("复制失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    // 重命名区域
    const renameRegion = (inputValue) => {
        if (loading) return;
        setRenameRegionUuid(null);
        if (inputValue == null || inputValue === '') {
            message.warning("区域名称不能为空");
            return;
        }
        const index = regions.findIndex(r => r.uuid == renameRegionUuid);
        if (index === -1) {
            message.warning("区域不存在");
            return;
        }
        const region = { ...regions[index] };
        if (inputValue === region.name) {
            return;
        }
        region.name = inputValue;
        setLoading(true);
        updateRegion(renameRegionUuid, region).then(res => {
            regions[index] = region;
            setRegions([...regions]);
            // message.success("修改成功");
        }).catch(err => {
            console.log('err', err)
            message.error("修改失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    /**
     * 打散轴网并重绘
     * @param primitives 
     */
    const reBreakAxisNet = (primitives) => {
        // 激活打散轴网图元
        engineContext?.engine.eventMediator.emitEvent({
            cmd: 'CMD',
            data: EventGraphRedrawAxisNet.cmd,
        });
        let pythaEventObject = new PythaEventObject();
        pythaEventObject.data = { axisNetPrimitives: primitives || [] };
        engineContext.engine.eventMediator?.emitEvent(pythaEventObject);
    }

    /**
     * 重新生成竖向轴线
     * @param deleteStoreys 
     * @param storeys 
     */
    const reGenVLine = (deleteStoreys, storeys) => {
        // 激活打散轴网图元
        engineContext?.engine.eventMediator.emitEvent({
            cmd: 'CMD',
            data: EventGraphGenVerticalAxisLine.cmd,
        });
        let pythaEventObject = new PythaEventObject();
        pythaEventObject.data = {
            storeys: storeys || [],
            deleteStoreys: deleteStoreys || [],
        };
        engineContext.engine.eventMediator?.emitEvent(pythaEventObject);
    }

    /**
     * 编辑轴网
     */
    const activeEditStoreyAxisNet = (storey) => {
        if (!storey) return;
        if (storey?.axisNetUuid) {
            // 判断是否需要添加storeyUuids
            if (!activeStoreyUuids?.includes(storey?.axisNetUuid)) {
                setActiveStoreyUuids([...activeStoreyUuids, storey?.axisNetUuid])
            }
            // 添加到需要显示的轴网图元数组中
            positionContext.pushAxisNetToArray([storey?.axisNetUuid]);
            // 设置当前层为非锁定
            positionContext.editingStorey(storey);
        }
    }

    // 点击楼层
    const onClickStorey = (storeyUuid: string, storey: Storey) => {
        dbClickRef.current = false;
        setTimeout(() => {
            if (dbClickRef.current) return;
            // 设置激活层为选中的层
            setActiveStoreyUuid(storeyUuid);

            setActiveStoreyUuids(pre => {
                let selectAxisNetUuids = []
                let unSelectAxisNetUuids = []

                if (!pre) pre = [];
                let newArr = [...pre];
                const idx = pre?.findIndex(item => item === storeyUuid);
                if (idx === -1) {
                    let idx1 = activeRegion?.storeys?.findIndex(item => item.uuid === storeyUuid);
                    if (idx1 !== -1 && activeRegion?.storeys[idx1]?.axisNetUuid) {
                        selectAxisNetUuids.push(activeRegion?.storeys[idx1]?.axisNetUuid);
                    }
                    newArr.push(storeyUuid);
                } else {
                    let idx2 = activeRegion?.storeys?.findIndex(item => item.uuid === storeyUuid);
                    if (idx2 !== -1 && activeRegion?.storeys[idx2]?.axisNetUuid) {
                        unSelectAxisNetUuids.push(activeRegion?.storeys[idx2]?.axisNetUuid);
                    }
                    newArr.splice(idx, 1);
                }

                if (engineContext?.engine?.storage && !location.pathname.includes('axis-net')) {
                    const storage = engineContext?.engine?.storage;
                    const primitiveList: Primitive[] = Object.keys(storage.primitiveStore.primitiveDict)?.map(key => storage.primitiveStore.primitiveDict[key]) || [];

                    const needSelectUuidList = primitiveList?.map(item => {
                        // 轴网本身可以选中，返回true
                        if (selectAxisNetUuids?.some(anu => anu === item?.uuid)) return item.uuid;
                        // 打散的轴线段可以选中，返回true
                        if (selectAxisNetUuids?.some(anu => anu === (item as AxisNetPrimitive)?.axisNetUuid)) return item.uuid;
                        return null;
                    })?.filter(item => !!item) || [];

                    const cancelSelectUuidList = storage.selectStore.selectPrimitives?.map(item => {
                        if (unSelectAxisNetUuids?.some(anu => anu === item?.uuid)) return item.uuid;
                        if (unSelectAxisNetUuids?.some(anu => anu === (item as AxisNetPrimitive)?.axisNetUuid)) return item.uuid;
                        return null;
                    })?.filter(item => !!item) || [];

                    let event = new PythaEventSetting();
                    event.data = {
                        key: SETTING_KEY.FORCE_SELECT,
                        value: {
                            needSelectUuidList: needSelectUuidList,
                            needCancelSelectUuidList: cancelSelectUuidList
                        },
                    }
                    engineContext.engine.eventMediator?.emitEvent(event);
                }

                return newArr;
            })
            positionContext.toggleAxisNetToArray([storey.axisNetUuid]);
        }, 200);
    }

    /**
     * 跳转到空间定位页签，并且显示所有的轴网
     */
    const toggleAllGrid = () => {
        if (!projectUuid) return;
        // 跳转到空间定位的页签
        let axisNetUuids = [];
        if (regions?.length > 0) {
            regions?.forEach(region => {
                region?.storeys?.forEach(storey => {
                    if (storey?.axisNetUuid) {
                        axisNetUuids.push(storey?.axisNetUuid);
                    }
                })
            })
        }
        positionContext.updateAxisNetUuids(axisNetUuids);
        if (!location.pathname.includes('axis-net')) {
            navigate(`/projects/${projectUuid}/axis-net`);
        }
    }

    /**
     * 点击添加按钮，显示添加选项弹窗
     */
    const onAddClick = () => {
        let dom = document.getElementById("add-svg")
        if (!dom) return
        const rect = dom.getBoundingClientRect();
        setContextMenuLeft(rect.left - 4);
        setContextMenuTop(rect.bottom + 8);
        setContextMenuVisible(true)

    }

    return <div className='position-panel'>
        <SideHeader>
            <div className='header'>
                {/* <div className="header-title">轴网</div> */}
                <AddSvg id="add-svg" className='icon' onClick={onAddClick} />
                {positionContext.fastGenVisible ? <FastGenGreenSvg className='icon'
                    onClick={() => positionContext.setFastGenVisible(false)}
                /> : <FastGenSvg className='icon' onClick={() => positionContext.setFastGenVisible(true)} />}
                {/* <div className={classNames({
                    'grid-icon': true,
                    'grid-icon-active': location.pathname.includes('axis-net'),
                })} onClick={toggleAllGrid}>
                    {location.pathname.includes('axis-net') ? <GridWhiteSvg /> : <GridSvg />}
                </div> */}
            </div>
        </SideHeader>
        <div className='content'>

            <LeftSideList
                minStyle
                leftItems={regions}
                uniqueKey='uuid'
                activeLeftItemKey={activeRegion?.uuid}
                onClickLeftItem={(e, region) => {
                    setActiveRegion(region);
                }}
                onDbClickLeftItem={(e, region) => activeRenameRegion(region.uuid)}
                onContextMenuLeftItem={(e, region) => handleRtx(e, region.uuid)}
                leftItemUpdateUuid={BaseUtils.genUUID()}
                // onClickAddIcon={handleClickAddRegion}
                noNeedAddIcon={true}
                leftItemContainer={({ leftItem }) => {
                    return (
                        <>
                            {renameRegionUuid !== leftItem.uuid && <div className={classNames({
                                'region-name': true,
                                'region-name-active': activeRegion?.uuid === leftItem.uuid,
                            })} title={leftItem.name}>{leftItem.name}</div>}
                            {renameRegionUuid === leftItem.uuid &&
                                <Input
                                    autoFocus
                                    defaultValue={inputValue}
                                    // value={inputValue}
                                    // onChange={(e) => setInputValue(e.target.value)}
                                    style={{ height: 32 }}
                                    onBlur={(e) => renameRegion(e.target.value)}
                                    onEnter={(e) => renameRegion((e.target as any).value)}
                                />}
                        </>
                    );
                }}
            >
                <div className='story-list'>
                    <div className='storey-row-head'>
                        {/* <div className='dot'><SelectDot hidden /></div> */}
                        <div className='name'>层名</div>
                        <div className='height'>层高</div>
                        <div className='elevation'>标高</div>
                        {/* <div className=''><IconButton icon={<AddSvg />} onClick={(e) => handleClickAddStorey(e, activeRegion)}></IconButton></div> */}
                    </div>
                    {activeRegion?.storeys?.map((storey) => {
                        return (
                            <div
                                className={classNames({
                                    'storey-row': true,
                                    'active': positionContext?.activeStorey?.uuid === storey?.uuid
                                })}
                                key={storey.uuid}
                                // onClick={() => { onClickStorey(storey.uuid, storey) }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    activeEditStoreyAxisNet(storey);
                                }}
                                // onContextMenu={(e) => handleRtx(e, region.uuid, storey.uuid)}
                                onContextMenu={(e) => handleRtx(e, activeRegion?.uuid, storey.uuid)}
                                // onDoubleClick={(e) => handleDbClickInput(e, index, storey.uuid, EditColType.ALL)}
                                onDoubleClick={(e) => handleDbClickInput(e, storey, EditColType.ALL)}
                                onMouseEnter={() => setHoverStoreyUuid(storey.uuid)}
                                onMouseLeave={() => setHoverStoreyUuid(null)}
                            >
                                {/* <div className='dot' onClick={(e) => { e.stopPropagation();onClickStorey(storey.uuid, storey) }}> */}
                                {/* <SelectDot
                                        // active={activeStoreyUuids?.includes(storey?.uuid)}
                                        hidden={hoverStoreyUuid !== storey?.uuid}
                                        active={positionContext?.axisNetUuids?.includes(storey?.axisNetUuid)}
                                    /> */}
                                {/* </div> */}
                                <div className='name ellipsis'>
                                    {(editStoreyUuid !== storey.uuid || (editCol !== EditColType.name && editCol !== EditColType.ALL)) &&
                                        <span onDoubleClick={(e) => handleDbClickInput(e, storey, EditColType.name)}>{storey?.name}</span>}
                                    {editStoreyUuid === storey.uuid && (editCol === EditColType.name || editCol === EditColType.ALL) &&
                                        <>
                                            <Input
                                                onBlur={(e) => handleUpdateStorey(storey)}
                                                onEnter={(e) => handleUpdateStorey(storey)}
                                                autoFocus
                                                value={inputValueName}
                                                onChange={(e) => setInputValueName(e.target.value)}
                                            />
                                        </>
                                    }
                                </div>
                                <div className='height'>
                                    {(editStoreyUuid !== storey.uuid || (editCol !== EditColType.height && editCol !== EditColType.ALL)) &&
                                        <span onDoubleClick={(e) => handleDbClickInput(e, storey, EditColType.height)}>{storey?.height?.toFixed(0)}</span>}
                                    {editStoreyUuid === storey.uuid && (editCol === EditColType.height || editCol === EditColType.ALL) &&
                                        <>
                                            <Input
                                                onBlur={(e) => handleUpdateStorey(storey)}
                                                onEnter={(e) => handleUpdateStorey(storey)}
                                                autoFocus
                                                value={inputValue}
                                                onChange={(e) => setInputValue(e.target.value)}
                                            />
                                        </>
                                    }
                                </div>
                                <div className='elevation'>
                                    {(editStoreyUuid !== storey.uuid || (editCol !== EditColType.elevation && editCol !== EditColType.ALL)) &&
                                        <span onDoubleClick={(e) => handleDbClickInput(e, storey, EditColType.elevation)}>{storey?.elevation?.toFixed(3)}</span>}
                                    {editStoreyUuid === storey.uuid && (editCol === EditColType.elevation || editCol === EditColType.ALL) &&
                                        <>
                                            <Input
                                                onBlur={(e) => handleUpdateStorey(storey)}
                                                onEnter={(e) => handleUpdateStorey(storey)}
                                                autoFocus
                                                value={inputValueElevation}
                                                onChange={(e) => setInputValueElevation(e.target.value)}
                                            />
                                        </>
                                    }
                                </div>
                                {editStoreyUuid === storey.uuid && editCol === EditColType.ALL &&
                                    <div className='edit-icons'>
                                        <IconButton wrapClassName='sm-icon' small icon={<CircleConfirmSvg />} onClick={(e) => handleUpdateStorey(storey, true)} />
                                        <IconButton wrapClassName='sm-icon' small icon={<CircleCancelSvg />} onClick={(e) => {
                                            setEditStoreyUuid(null);
                                        }} />
                                    </div>
                                }
                                {/* {(hoverStoreyUuid === storey.uuid && editStoreyUuid !== storey.uuid || positionContext?.activeStorey?.uuid === storey?.uuid) &&
                                    <div className='edit-icons'>
                                        <IconButton icon={positionContext?.activeStorey?.uuid === storey?.uuid ? <FastGenWhiteSvg /> : <FastGenSvg />}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                activeEditStoreyAxisNet(storey);
                                            }}
                                            wrapClassName={classNames({
                                                'edit-active': positionContext?.activeStorey?.uuid === storey?.uuid
                                            })}
                                        />
                                    </div>
                                } */}
                            </div>
                        )
                    })}
                </div>
            </LeftSideList>



            <ContextMenuModal visible={rtxVisible} left={rtxLeft} top={rtxTop} onCancel={() => {
                setRtxVisible(false);
                setRtxRegionUuid(null);
                setRtxStoreyUuid(null);
            }} wrapperClassname="positon-container-add-menu">
                <MenuList>
                    {rtxRegionUuid != null && rtxStoreyUuid == null && <MenuItem onClick={() => activeRenameRegion(activeRegion?.uuid)}>重命名区域</MenuItem>}
                    {rtxRegionUuid != null && rtxStoreyUuid == null && <MenuItem onClick={activeDeleteRegion}>删除区域</MenuItem>}
                    {rtxStoreyUuid != null && <MenuItem onClick={() => activeCopyStorey()}>复制轴网</MenuItem>}
                    {rtxStoreyUuid != null && <MenuItem onClick={() => activeEditStoreyAxisNet(rtxStoreyUuid)}>编辑轴网</MenuItem>}
                    {rtxStoreyUuid != null && <MenuItem onClick={() => activeDeleteStorey()}>删除楼层</MenuItem>}
                </MenuList>
            </ContextMenuModal>

            <ContextMenu
                // wrapperClassname="add-storey-menu"
                visible={contextMenuVisible}
                left={contextMenuLeft}
                top={contextMenuTop}
                width={40}
                onCancel={() => { setContextMenuVisible(false) }}
            >
                <MenuList>
                    <MenuItem onClick={() => {
                        handleClickAddRegion()
                        setContextMenuVisible(false)
                    }}>
                        {/* <BlackAddSvg style={{ marginRight: 8 }} /> */}
                        区域
                    </MenuItem>
                    <MenuItem onClick={() => {
                        handleClickAddStorey(activeRegion)
                        setContextMenuVisible(false)
                    }}>
                        {/* <BlackAddSvg style={{ marginRight: 8 }} /> */}
                        楼层
                    </MenuItem>
                </MenuList>
            </ContextMenu>

        </div>
    </div >
}